import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

// Error handling cho browser extensions - phải đặt ở đầu file
(function() {
  // Ẩn lỗi từ browser extensions
  const originalConsoleError = console.error;
  const originalConsoleWarn = console.warn;
  const originalConsoleLog = console.log;
  
  const isExtensionError = (message) => {
    if (typeof message !== 'string') return false;
    return message.includes('runtime.lastError') ||
           message.includes('message port closed') ||
           message.includes('Could not establish connection') ||
           message.includes('Receiving end does not exist') ||
           message.includes('The message port closed before a response was received') ||
           message.includes('Understand this error') ||
           message.includes('Unchecked runtime.lastError');
  };

  console.error = function(...args) {
    const message = args.join(' ');
    if (isExtensionError(message)) {
      return; // Không hiển thị lỗi từ extensions
    }
    originalConsoleError.apply(console, args);
  };

  console.warn = function(...args) {
    const message = args.join(' ');
    if (isExtensionError(message)) {
      return; // Không hiển thị warning từ extensions
    }
    originalConsoleWarn.apply(console, args);
  };

  console.log = function(...args) {
    const message = args.join(' ');
    if (isExtensionError(message)) {
      return; // Không hiển thị log từ extensions
    }
    originalConsoleLog.apply(console, args);
  };

  // Ẩn lỗi từ DevTools và extensions
  window.addEventListener('error', function(e) {
    if (e.message && isExtensionError(e.message)) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  });

  // Ẩn unhandled promise rejections từ extensions
  window.addEventListener('unhandledrejection', function(e) {
    if (e.reason && e.reason.message && isExtensionError(e.reason.message)) {
      e.preventDefault();
      return false;
    }
  });

  // Override window.onerror
  const originalOnError = window.onerror;
  window.onerror = function(message, source, lineno, colno, error) {
    if (message && isExtensionError(message)) {
      return true; // Ngăn lỗi hiển thị
    }
    if (originalOnError) {
      return originalOnError.apply(this, arguments);
    }
    return false;
  };
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
